<template>
  <IconSvgBase :class="$style.icon" :view-width="38" :view-height="38">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.9629 14.0371C23.2461 13.3203 22.0874 13.3203 21.3706 14.0371L19.0001 16.4076L16.6296 14.0371C15.9127 13.3203 14.7541 13.3203 14.0372 14.0371C13.3204 14.754 13.3204 15.9126 14.0372 16.6295L16.4077 19L14.0372 21.3705C13.3204 22.0873 13.3204 23.246 14.0372 23.9628C14.3947 24.3203 14.8641 24.5 15.3334 24.5C15.8027 24.5 16.2721 24.3203 16.6296 23.9628L19.0001 21.5923L21.3706 23.9628C21.7281 24.3203 22.1974 24.5 22.6667 24.5C23.1361 24.5 23.6054 24.3203 23.9629 23.9628C24.6797 23.246 24.6797 22.0873 23.9629 21.3705L21.5924 19L23.9629 16.6295C24.6797 15.9126 24.6797 14.754 23.9629 14.0371ZM19.0001 33.6666C10.9132 33.6666 4.33341 27.0868 4.33341 19C4.33341 10.9131 10.9132 4.33329 19.0001 4.33329C27.0869 4.33329 33.6667 10.9131 33.6667 19C33.6667 27.0868 27.0869 33.6666 19.0001 33.6666ZM19.0001 0.666626C8.89108 0.666626 0.666748 8.89096 0.666748 19C0.666748 29.109 8.89108 37.3333 19.0001 37.3333C29.1091 37.3333 37.3334 29.109 37.3334 19C37.3334 8.89096 29.1091 0.666626 19.0001 0.666626Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconCloseCircle',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;

  &__path {
    fill: currentcolor;
  }
}
</style>
